import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React, { Fragment } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import Translate from 'components/Translate';
import { IOrderBump, IProduct, IProductData } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { CurrencyFormat } from '../../CurrencyFormat';
import { getCdnImage } from 'functions';
import { WithStyles } from 'shared/decorators/withStyles';
import OrderBumpAddressForm from './OrderBumpAddressForm';
import OrderBumpQuantityForm from './OrderBumpQuantityForm';
import { enProductType } from 'enums/enProductType';
import OrderBumpShippingForm from './OrderBumpShippingForm';
import { enShippingType } from 'enums/enShippingType';
import { paymentService } from 'services/PaymentService';

interface IState extends IStateBase {
  orderBumpProducts: IOrderBump[];
  orderBumpProductsSelected: string[];
  product: IProduct;
  productsIds: string[];
}

@WithStyles(() => ({
  component: {
    border: '2px dashed #009358',
    marginTop: '16px',
    width: '100%',
    '& .orderBumpOffer': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      padding: '16px',
      '& .productImage': {
        height: '70px',
        margin: '0 8px 0 0',
        minHeight: '70px',
        minWidth: '70px',
        width: '70px',
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }
      },
      '& .orderBumpDescription': {
        '& h1': {
          color: '#009358',
          fontSize: '0.888rem',
          margin: 0,
          textAlign: 'left'
        },
        '& span': {
          color: '#596375',
          fontSize: '0.777rem',
          '& .theme-orderbump-highlight, & .theme-orderbump-highlight span': {
            color: '#009358',
            fontWeight: 'bold'
          }
        }
      }
    },
    '& .orderBumpSelector': {
      backgroundColor: '#009358',
      cursor: 'pointer',
      padding: '0 16px',
      '& label': {
        transform: 'translate(0, 0) scale(1)',
        whiteSpace: 'normal'
      },
      '& span': {
        color: '#FFF',
        fontSize: '0.7rem',
        fontWeight: 'bold'
      }
    }
  }
}))
export default class OrderBump extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      orderBumpProducts: null,
      orderBumpProductsSelected: [],
      product: null,
      productsIds: []
    };
  }

  componentDidMount() {
    cartService
      .getCart()
      .filter((cart: IProductData) => !!cart)
      .bindComponent(this)
      .subscribe((cart: IProductData) => {
        const orderBumpProducts = cart.orderBump;
        this.setState({ orderBumpProducts });

        const productsIds = cart.products.map(p => p.id.toString());
        this.setState({ productsIds });

        if (!orderBumpProducts || orderBumpProducts.length < 1) {
          return;
        }

        const product: IOrderBump = orderBumpProducts.find((ob: IOrderBump) => productsIds.includes(ob.contentId.toString()));

        if (!product) {
          return;
        }

        const productData: IProduct = cart.products.find((p: IProduct) => p.id.toString() === product.contentId.toString());
        this.setState({ product: productData });

        if (!productData) {
          paymentService.setBlockAddressAfterPayment(false);
        }
      });
  }

  addOrderBump = (event: React.FormEvent<HTMLInputElement>) => {
    const orderBumpProductsSelected = JSON.parse(JSON.stringify(this.state.orderBumpProductsSelected));
    const productId = event.currentTarget.value;

    if (event.currentTarget.checked) {
      orderBumpProductsSelected.push(productId);
    }

    if (!event.currentTarget.checked) {
      const index = orderBumpProductsSelected.indexOf(productId);
      orderBumpProductsSelected.splice(index, 1);
    }

    this.setState({ orderBumpProductsSelected });

    cartService
      .setOrderBumps(orderBumpProductsSelected)
      .loader()
      .subscribe(cart => {
        const product = cart.products.find((p: IProduct) => p.id.toString() === productId);

        this.setState({ product });

        if (!product) {
          paymentService.setBlockAddressAfterPayment(false);
        }
      });
  };

  render() {
    if (!this.state || !this.state.orderBumpProducts) {
      return null;
    }

    const { orderBumpProductsSelected, orderBumpProducts, product, productsIds } = this.state;

    const image = getCdnImage(orderBumpProducts[0].logo);

    return (
      <Fragment>
        {orderBumpProducts.slice(0, 1).map((bump: IOrderBump) => (
          <div className={`${this.props.classes.component} theme-orderbump`} key={bump.contentId}>
            <div className="orderBumpOffer">
              <div className="productImage">{image && <img src={image} />}</div>
              <div className="orderBumpDescription">
                <h1 className="theme-orderbump-highlight">
                  <Translate term="Oferta Imperdível" />
                </h1>
                <span>
                  {bump.price === 0 && bump.shipping ? (
                    <Translate
                      term="Adquira também o produto {product} pagando APENAS o frete!"
                      properties={{
                        product: <span className="theme-orderbump-highlight">{bump.title}</span>
                      }}
                    />
                  ) : (
                    <Translate
                      term={`Adquira também por apenas {price} ${
                        bump.shipping ? (bump.shipping.type === enShippingType.FREE ? '+ frete grátis' : '+ frete') : ''
                      } o produto {product}`}
                      properties={{
                        price: (
                          <span className="theme-orderbump-highlight">
                            <CurrencyFormat value={bump.price} />
                          </span>
                        ),
                        product: <span className="theme-orderbump-highlight">{bump.title}</span>
                      }}
                    />
                  )}
                </span>
              </div>
            </div>
            <div className="orderBumpSelector theme-orderbump-selector">
              <FormControlLabel
                control={
                  <Checkbox
                    id={'chk-check-order-bump'}
                    className="orderBumpCheckbox"
                    value={String(bump.contentId)}
                    checked={orderBumpProductsSelected.includes(String(bump.contentId)) || productsIds.includes(String(bump.contentId))}
                    onChange={this.addOrderBump}
                  />
                }
                label={<Translate term="Sim, quero adicionar esta oferta em minha compra" />}
              />
            </div>
            <div>
              {(orderBumpProductsSelected.includes(String(bump.contentId)) || productsIds.includes(String(bump.contentId))) && !!product && (
                <OrderBumpQuantityForm
                  productId={product.id.toString()}
                  limit={product.purchaseLimit || 999999}
                  hideQuantity={bump.hideQuantity || bump.type !== enProductType.PHYSICAL}
                />
              )}
            </div>
            <div>
              {(orderBumpProductsSelected.includes(String(bump.contentId)) || productsIds.includes(String(bump.contentId))) && (
                <Fragment>
                  <OrderBumpAddressForm product={bump} />
                  <OrderBumpShippingForm product={bump} />
                </Fragment>
              )}
            </div>
          </div>
        ))}
      </Fragment>
    );
  }
}
